module.exports = __webpack_public_path__ + "static/img/share_popup_bg2.591cb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/online/share_popup_bg2.png
// module id = bsqr
// module chunks = 1